'use strict';


/** @namespace */
module.exports = {
    layouts: {
        tvChannel: 1, // tv channel item with playback and epg now
        video: 2,  // moview preview with play now item
        record: 3, // audio preview with play now item
        static: 4, // static item by default
        application: 5
    },
    geometry: {
        square: 1,
        horizontal: 2,
        vertical: 3,
        round: 4
    },
    actions: { // actions which can be applied to item
        favorite: 1,
        accessControl: 2,
        expandItemContent: 3
    }
};
